import { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
//@ts-ignore
import {db} from '../../utils/firebase.js'

const EditUser = () => {
  const [formData, setFormData] = useState({
    email: '',
    status: 'active',
  });

  const handleChange = (e : React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e : React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //console.log('Edit User Data Submitted:', formData);
    // Add your user status update logic here
    if (!formData.email || !formData.status) {
      toast.error("Email and status is required!");
      return;
    }

    try {
      const userDocRef = doc(db, "userDetails", formData.email);
      await updateDoc(userDocRef, {
        email: formData.email,
        status: formData.status
      });
  
      toast.success("Data updated successfully!");
  
      setFormData({
        email: "",
        status: "",
      });
  
    } catch (error: any) {
      console.error("Error updating Status");
      toast.error("The email is not registered with our business, please register user first");
      setFormData({
        email: "",
        status: "",
      });
    }
    

  };

  return (
    <div className="max-w-2xl bg-white rounded-lg shadow p-4 lg:p-6">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <h2 className="text-xl font-bold mb-6">Edit User Status</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Status (Active/Inactive) */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Status</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            required
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {/* Update Button */}
        <div>
          <button
            type="submit"
            className="w-full bg-[#0b3a28] text-white px-6 py-2 rounded-lg hover:bg-[#1c2822]"
          >
            Update Status
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditUser;